module.exports = __webpack_public_path__ + "static/media/hukusyakin.f9ed3b75.png";